import { FtuxConfig, FtuxStep } from '../types';
import { ensureLastStepIsDone } from './utils';

export const getRecordReadingConfig = (readingType: 'GPK' | 'non-word'): FtuxConfig => {
	const assessmentName = readingType === 'GPK' ? 'Grapheme Phoneme Knowledge' : 'Reading non-words';
	const conductButtonSubtitle = `Click here to conduct your ${assessmentName} assessment in real time. Any results will be updated in the table below.`;

	const steps: FtuxStep[] = [
		{
			type: 'modal' as const,
			title: 'Recording assessment results',
			subtitle:
				'You can conduct and record student assessment data for each Little Learners assessment for a particular assessment period on the Online Platform.',
			image: '/img/ftux-record-reading-1.png',
			button: {
				label: 'Next',
				type: 'paginated' as const,
				hasBackButton: false
			},
			modalPosition: 'bottom-right' as const,
			hasBackdrop: false
		},
		{
			type: 'tooltip' as const,
			target: '#conduct-assessment-button',
			subtitle: conductButtonSubtitle,
			tooltipPlacement: 'bottom' as const,
			button: {
				label: 'Next',
				type: 'paginated' as const
			},
			hasBackdrop: false
		},
		{
			type: 'tooltip' as const,
			target: '#recording-date',
			subtitle: 'Click here to change the assessment recording date.',
			tooltipPlacement: 'bottom' as const,
			button: {
				label: 'Next',
				type: 'paginated' as const
			},
			hasBackdrop: false
		},
		{
			type: 'tooltip' as const,
			target: '#student-view',
			subtitle: 'Quickly switch to another student in the same class by clicking here.',
			tooltipPlacement: 'bottom' as const,
			button: {
				label: 'Next',
				type: 'paginated' as const
			},
			hasBackdrop: false
		},
		{
			type: 'tooltip' as const,
			target: '#graphene-spelling-letter',
			subtitle:
				'Click a tile to mark it as correct and click it again to switch it to incorrect. Correct answers will appear green and incorrect answers red for quick identification.',
			tooltipPlacement: 'bottom' as const,
			button: {
				label: 'Next',
				type: 'paginated' as const
			},
			hasBackdrop: false
		},
		{
			type: 'tooltip' as const,
			target: '#student-word-marking-buttons',
			subtitle:
				'Click the tick or cross button to mark the entire question as correct/incorrect.<br/><br/><strong>Tip:</strong> You can use this in conjunction with the tile buttons to mark fully correct first and then specific tiles incorrect.',
			tooltipPlacement: 'bottom' as const,
			button: {
				label: 'Next',
				type: 'paginated' as const
			},
			hasBackdrop: false
		},
		{
			type: 'tooltip' as const,
			target: '#notes-view',
			subtitle: 'Add supporting notes for any incorrect answers for future reference.',
			tooltipPlacement: 'bottom' as const,
			button: {
				label: 'Next',
				type: 'paginated' as const
			},
			hasBackdrop: false
		},
		{
			type: 'tooltip' as const,
			target: '#score-view',
			subtitle:
				'Each question with all correct tile(s) will add 1 point to the total score.<br/><br/>Questions marked with some or all tiles marked incorrect will not add any additional points to the score.',
			tooltipPlacement: 'left' as const,
			button: {
				label: 'Next',
				type: 'paginated' as const
			},
			hasBackdrop: false
		}
	];

	const config: FtuxConfig = {
		id: 'record-reading-ftux',
		name: 'Record Reading Tutorial',
		showSkipButton: false,
		steps
	};

	// Ensure the last step always has "Done" as the label
	return ensureLastStepIsDone(config);
};
